<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">发型师管理>疫情申报</div>
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">疫情申报</div>
		</div>
		<div class="right">
			<router-link to="/">
				<el-button type="primary" style="margin: 10px;" @click="getCovidExpor">导出</el-button>
			</router-link>
		</div>
		<div>
			<el-table :data="tabledata" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="workerName" label="申报发型师姓名" align="center"></el-table-column>
				<el-table-column prop="storeName" label="所在门店" align="center"></el-table-column>
				<el-table-column prop="time" label="最近服务时间" align="center"></el-table-column>
				<el-table-column prop="reason" label="申报理由" align="center"></el-table-column>
				<el-table-column prop="telephone" label="申报用户手机号" align="center"></el-table-column>
			</el-table>
		</div>
		<div class="pagescg">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
				layout=" sizes, prev, pager, next, jumper" :total="query.total" align="center">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				tabledata: [],
				query: {
					page: 1,
					size: 10,
					total: 100,
				},
			}
		},
		methods: {
			handleSizeChange(val) {
				this.query.size = val;
				this.getCovid();
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getCovid();
			},
			getCovid() {
				let q = {
					pageSize: this.query.size,
					pageNum: this.query.page
				}
				this.$http.post("dWorker/covidUpload", JSON.stringify(q)).then(function(res) {
					this.tabledata = res.body.data;
					this.query.total = res.body.total;
				}, function(err) {
					this.$message.error("请求失败");
				})
			},
			getCovidExpor() {
				window.location.assign(this.url + "dWorker/covidUploadExpor");
			}
		},
		mounted() {
			this.getCovid();
		}
	}
</script>

<style>
	.title {
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>